import fileSaver from 'file-saver'

export default ({ $config }, inject) => {
  inject('fs', fileSaver)
}
